import { NoResultComponent } from '@/app/components/shared/no-result/no-result.component';
import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { BreadcrumbsComponent } from '../../components/shared/breadcrumbs/breadcrumbs.component';
import { FavoriteTabBarComponent } from './components';
import { EFavoriteTab } from './models';
import { WebsocketFavortiesService } from './services';
import {
  MyCompetitionsComponent,
  MyMatchesComponent,
  MyTeamsComponent,
} from './tabs';

@Component({
  selector: 'app-favorites',
  standalone: true,
  imports: [
    CommonModule,
    BreadcrumbsComponent,
    TranslateModule,
    FavoriteTabBarComponent,
    NoResultComponent,
    MyCompetitionsComponent,
    MyMatchesComponent,
    MyTeamsComponent,
  ],
  templateUrl: './favorites.component.html',
})
export class FavoritesComponent {
  private websocketFavortiesService = inject(WebsocketFavortiesService);
  urlIMG = environment.urlIMG;
  urlMatch: boolean = false;
  selectedIndex: number = 0;
  selectedHeaderTab = signal<EFavoriteTab>(EFavoriteTab.COMPETITION);

  handleFavoriteTab(tabValue: EFavoriteTab) {
    // google tag
    // this.googleTagAnalyticsService.event(
    //   EGoogleTagAnalyticsKeys.MATCH_DETAILS_CURRENT_TAB,
    //   {
    //     tab: headerTap[tabValue] || tabValue,
    //   }
    // );

    this.selectedHeaderTab.set(tabValue);
  }

  ngOnDestroy() {
    this.websocketFavortiesService.wsDisconnect();
  }
}
